<script setup>
  const { fight } = defineProps(['fight']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <Section autowrap wide>
    <BigTitle>
      <slot />
    </BigTitle>
    <Foreground>
      <UpcomingFightCard :fight="fight" />
    </Foreground>
  </Section>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  section {
    padding-top: px(90);
    padding-bottom: px(128);

    background-color: $black;

    @include break-small {
      background-color: $black-2;
      padding-bottom: px(28);
    }

    .foreground {
      @include break-min-large {
        @include column(2, 11);
        @include grid;
      }

      .card {
        @include column(2, 11);
      }
    }
  }
</style>
